import React from "react";
import { CurrencyLabel, StatusBadge } from "../../components";
import { GRID_COLUMN_EMPTY_ICONS } from "../../utils/Constants";
import dayjs from "dayjs";

// Checkout / link status values returned by the Manage Checkout API (details response)
export const LINK_STATUS = {
  ACTIVE: "ACTIVE",
  CANCELLED: "CANCELLED",
  EXPIRED: "EXPIRED",
};

// Checkout list status values (search response `status` field)
export const CHECKOUT_STATUS = {
  UNUSED_OTT: "UNUSED_OTT",
  INPROGRESS: "INPROGRESS",
  EXPIRED_OTT: "EXPIRED_OTT",
  CANCELLED: "CANCELLED",
  PROCESSED: "PROCESSED",
};

// Payment status values returned in the details response
export const PAYMENT_STATUS = {
  PENDING: "PENDING",
  SUCCESS: "SUCCESS",
  FAILED: "FAILED",
};

// Route helper
export const PAGE_ROUTE = {
  PAY_BY_LINK: "/skiply-portal/PayByLink",
};

// Column definitions for the AG Grid list
export const COLUMN_DEFS = [
  {
    headerName: "Order ID",
    field: "orderId",
    sortable: true,
    unSortIcon: true,
    suppressMenu: true,
    resizable: true,
    icons: GRID_COLUMN_EMPTY_ICONS,
    pinned: "left",
    flex: 1,
    minWidth: 140,
  },
  {
    headerName: "Customer name",
    field: "customerName",
    sortable: false,
    filter: false,
    suppressMenu: true,
    flex: 1.2,
    minWidth: 160,
  },
  {
    headerName: "Email",
    field: "email",
    sortable: false,
    filter: false,
    suppressMenu: true,
    flex: 1.5,
    minWidth: 220,
  },
  {
    headerName: "Date created",
    field: "createdAt",
    valueFormatter: (params) => {
      if (!params.value) return "";
      const d = dayjs(params.value);
      return d.isValid() ? d.format("DD/MM/YYYY") : params.value;
    },
    sortable: false,
    filter: false,
    suppressMenu: true,
    flex: 1,
    minWidth: 130,
  },
  {
    headerName: "Amount",
    field: "amount",
    sortable: false,
    filter: false,
    suppressMenu: true,
    flex: 1,
    minWidth: 120,
    cellRenderer: (params) => <CurrencyLabel amount={params.value ?? 0} />,
  },
  {
    headerName: "Link Status",
    field: "status",
    sortable: false,
    filter: false,
    suppressMenu: true,
    flex: 1,
    minWidth: 120,
    cellRenderer: (params) => <StatusBadge status={params.value} />,
  },
    {
    headerName: "Mobile number",
    field: "mobileNo",
    sortable: false,
    filter: false,
    suppressMenu: true,
    flex: 1.2,
    minWidth: 150,
  },
  {
    headerName: "Payment Status",
    field: "paymentStatus",
    sortable: false,
    filter: false,
    suppressMenu: true,
    pinned: "right",
    flex: 1,
    minWidth: 130,
    cellRenderer: (params) => <StatusBadge status={params.value} />,
  },
];

// Search categories map to API filter fields
export const SEARCH_CATEGORIES = [
  { label: "Order ID", value: "orderId" },
  { label: "Customer name", value: "customerName" },
  { label: "Email", value: "email" },
];

// Payment status filter options (maps to the `paymentStatus` field in the search request)
export const PAYMENT_STATUS_FILTER_OPTIONS = [
  { label: "All Payment Status", value: "" },
  { label: "Pending", value: PAYMENT_STATUS.PENDING },
  { label: "Success", value: PAYMENT_STATUS.SUCCESS },
  { label: "Failed", value: PAYMENT_STATUS.FAILED },
];

// Checkout status filter options (maps to the `status` field in the search request)
export const STATUS_FILTER_OPTIONS = [
  { label: "Link Status", value: "" },
  { label: "Active", value: CHECKOUT_STATUS.UNUSED_OTT },
  { label: "In Progress", value: CHECKOUT_STATUS.INPROGRESS },
  { label: "Expired", value: CHECKOUT_STATUS.EXPIRED_OTT },
  { label: "Cancelled", value: CHECKOUT_STATUS.CANCELLED },
  { label: "Processed", value: CHECKOUT_STATUS.PROCESSED },
];
